import { render } from "./HeroiconsOutlineXCircle.vue?vue&type=template&id=011ca5a4"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineXCircle.vue"]])

export default __exports__